import { HashLink as Link } from "react-router-hash-link";

const Services = () => {
  return (
    <section className="services-section" id="services">
      <div className="services-title">
        <h3>Nos services</h3>
        <h2>
          SOLUTIONS JURIDIQUES POUR LES BANQUES
          <br /> & INSTITUTIONS FINANCIÈRES
        </h2>
        <h4 className="text-blue">Recouvrement - Procédures - Conseils</h4>
      </div>
      <ul className="servies-card">
        <li>
          <img src={require("../../assets/img/ico/advice.png")} alt="" />
          <h3 className="text-blue">CONSEIL ET ASSISTANCE</h3>
          <p>
            Nous aidons les établissements bancaires à sécuriser leurs contrats,
            à anticiper les risques juridiques et à renforcer leur conformité
            réglementaire pour éviter d'éventuels litiges.
          </p>
        </li>
        <li>
          <img src={require("../../assets/img/ico/balance.png")} alt="" />
          <h3 className="text-blue">GESTION DES PROCÉDURES</h3>
          <p>
            Nous plaidons devant tous les Juges du Contentieux de la protection
            en France afin de préserver les droits des banques et défendre leurs
            intérêts face aux décisions d'effacement ou diminution de dettes.
            <br />
            <br />
            Nous formalisons les contestations de recevabilité et des mesures
            imposées par les commissions de surendettement aux intérêts des
            établissements bancaires.
          </p>
        </li>
        <li>
          <img src={require("../../assets/img/ico/approve.png")} alt="" />
          <h3 className="text-blue">RECOUVREMENT DE CRÉANCES</h3>
          <p>
            Nous accompagnons nos clients à chaque étape du processus.
            <br />
            <br /> Nous veillons à la conformité juridique des procédures tout
            en optimisant les chances d'un recouvrement rapide et efficace.
          </p>
        </li>
      </ul>
      <Link to="#contact" className="btn-empty">
        Nous contacter
      </Link>
    </section>
  );
};

export default Services;
